import React from 'react';
import { AxiosError, AxiosResponse } from 'axios';
import {
    AppBar, Button, Checkbox, CircularProgress, FormControlLabel, Grid, makeStyles, Typography, Link, Icon,
    Accordion, AccordionSummary, AccordionDetails
} from '@material-ui/core';

import { BasicConfirmDialog } from '../../../shared/components/BasicConfirmDialog';
import { PageLocation } from '../../../shared/enum/PageLocation';
import { AuthContext } from '../../Authentication/AuthContext';
import { HomeContext } from '../../Home/HomeContext';
import { NewsStatus } from '../enum/NewsStatus';
import { ErrorStatus } from '../../../shared/enum/ErrorStatus';
import { EditedNewsFieldModel } from '../../../Models/EditedNewsFieldModel';
import { NewsModel } from '../../../Models/NewsModel';
import { VehicleDictionaryModel } from '../../../Models/VehicleDictionaryModel';
import { InfluencerContext } from '../NewsContext';
import NewsData from '../components/NewsData';
import EditedNewsFieldService from '../../../Services/EditedNewsFieldService';
import NewsService from '../../../Services/NewsService';
import VehicleDictionaryService from '../../../Services/VehicleDictionaryService';
import { JournalistModel } from '../../../Models/JournalistModel';
import { ClassificationModel, classificationModelInitial } from '../../../Models/ClassificationModel';
import ClassificationService from '../../../Services/ClassificationService';
import { RestoreClassification } from '../components/RestoreClassification';
import { ClassificationStatus } from '../enum/ClassificationStatus';
import { Alert } from '@material-ui/lab';
import { NewsLoadingContext } from '../NewsLoadingContext';
import { LoadingStatus } from '../enum/LoadingStatus';
import { InfluencerModel } from '../../../Models/InfluencerModel';
import InfluencerService from '../../../Services/InfluencerService';
import NewsDataQuestions from '../components/NewsDataQuestions';
import InfluencerData, { validateInfluencerData } from '../components/InfluencerData';
import { DetachedClassificationAction } from '../enum/DetachedClassificationAction';
import { VehicleModel } from '../../../Models/VehicleModel';
import InfluencerDataQuestions from '../components/InfluencerDataQuestions';
import InfluencerDataReputacao, { validateInfluencerReviser } from '../components/InfluencerDataReputacao';
export interface INewsClassificationProps {
    spreadsheetId: number,
    influencerId: number,
    openList: boolean,
    setOpenList: (open: boolean) => void
}

const useStyles = makeStyles((theme) => ({
    root: {
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3),
    },
    buttonsTop: {
        textTransform: 'initial',
        color: theme.palette.primary.main,
    },
    toolbar: {
        marginTop: '64px',
        padding: '8px',
        backgroundColor: '#F0F1F1',
    },
    loading: {
        minHeight: '80vh'
    },
    gridContainer: {
        marginTop: theme.spacing(5),
        overflow: 'hidden',
        // maxWidth: '100%',
        padding: theme.spacing(10)
    },
    gridContainerClient: {
        // maxWidth: '100%',
        padding: theme.spacing(3)
    },
    gridContainerText: {
        marginTop: '8px',
        // maxWidth: '100%',
        padding: theme.spacing(1),
        // height: 'calc(100vh - 100px)'
    },
    gridEditNews: {
        marginTop: theme.spacing(3)
    },
    text: {
        padding: theme.spacing(2)
    },
    clickHereText: {
        paddingBottom: theme.spacing(2)
    },
    clickHereLink: {
        textDecoration: 'underline',
        color: theme.palette.primary.dark,
        fontWeight: 'bold',
        '&:hover': {
            cursor: 'pointer'
        }
    }
}));
type ErrosFormulario = Partial<Record<keyof InfluencerModel, string>>;

export default function InfluencerClassification() {
    const classes = useStyles();

    const authContext = React.useContext(AuthContext);
    const homeContext = React.useContext(HomeContext);
    const clientEnable = homeContext.influencerClientEnable;

    const newsContext = React.useContext(InfluencerContext);
    const newsLoadingContext = React.useContext(NewsLoadingContext);

    const [news, setNews] = React.useState<InfluencerModel | null>(null);
    const [questions, setQuestions] = React.useState<any[]>([]);
    const [errorQuestions, setErrorQuestions] = React.useState<Record<string, any>>({});
    const [statusClassification, setStatusClassification] = React.useState<Record<string, any>>({});
    const [newsList, setNewsList] = React.useState<InfluencerModel[]>([]);
    const [newsIndex, setNewsIndex] = React.useState<number>(0);
    const [newsCurrentId, setNewsCurrentId] = React.useState<number | null>(null);
    const [vehicle, setVehicle] = React.useState<VehicleModel | null>(null);
    const [vehicleMetricCorrect, setVehicleMetricCorrect] = React.useState<boolean>(false);
    const [errorDataStatus, setErrorDataStatus] = React.useState<ErrorStatus | null>(null);
    const [errorCategorizationStatus, setErrorCategorizationStatus] = React.useState<ErrorStatus | null>(null);
    const [errorAtLeastOneCategorizationStatus, setErrorAtLeastOneCategorizationStatus] = React.useState<ErrorStatus | null>(null);
    const [listNewsPending, setListNewsPending] = React.useState<InfluencerModel[]>([]);
    const [keepData, setKeepData] = React.useState<boolean>(false);
    const [classification, setClassification] = React.useState<ClassificationModel | null>(null);
    const [tabListSelected, setTabListSelected] = React.useState<number>(0);
    const [detachedNewsDataAction, setDetachedNewsDataAction] = React.useState<DetachedClassificationAction | null>(null);
    const [detachedNewsCategorizationAction, setDetachedNewsCategorizationAction] = React.useState<DetachedClassificationAction | null>(null);

    const [openList, setOpenList] = React.useState<boolean>(true);
    const [loading, setLoading] = React.useState<boolean>(false);
    const [showConfirmExit, setShowConfirmExit] = React.useState<boolean>(false);
    const [copyClassification, setCopyClassification] = React.useState<InfluencerModel | null>(null);
    const [hasNotError, setHasNotError] = React.useState<boolean>(false);
    const [erros, setErros] = React.useState<ErrosFormulario>({} as ErrosFormulario);

    const [showErrors, setShowErrors] = React.useState(false);
    const spreadsheetId = homeContext.spreadsheetId;


    React.useEffect(() => {
        fetchInfluencer();
    }, [homeContext.spreadsheetId]);

    const fetchInfluencer = async () => {
        InfluencerService.getInfluencerById(homeContext.spreadsheetId!)
            .then((res: AxiosResponse) => {
                setNews(res.data[0]);
                setNewsCurrentId(res.data[0].id);
            })
            .catch((error: AxiosError) => { homeContext.showError('', error); });
    };




    React.useEffect(() => {
        setClassification(classificationModelInitial);
        // fetchNews();
    }, [newsCurrentId]);

    React.useEffect(() => {
        if (errorDataStatus == ErrorStatus.HAS_NOT_ERROR && errorCategorizationStatus == ErrorStatus.HAS_NOT_ERROR) {
            setHasNotError(true);
        }
        else if ((errorDataStatus == ErrorStatus.HAS_ERROR ||
            errorCategorizationStatus == ErrorStatus.HAS_ERROR) &&
            errorAtLeastOneCategorizationStatus !== ErrorStatus.HAS_ERROR) {
            homeContext.showError('Ops.. existem campos com preenchimento inválido. Por favor, verifique os campos acima e tente novamente.');
        }
    }, [errorDataStatus, errorCategorizationStatus]);

    React.useEffect(() => {
        fetchQuestions();
        fetchInfluencerStatus();
    }, [newsCurrentId]);

    const fetchQuestions = () => {
        newsCurrentId && clientEnable &&
            InfluencerService.getAllClientQuestions(clientEnable?.id_cliente).then((response) => {
                const allQuestions = response.data;
                const newQuestions = allQuestions.map((question: any) => {
                    const answer = (news?.answers ?? []).find(el => el.id === question.id);
                    return { ...question, value: answer?.value ?? '' };
                });
                setQuestions(newQuestions);
            });
    };

    const fetchInfluencerStatus = () => {
        newsCurrentId &&
            InfluencerService.getStatusClassification().then((response) => {
                const updatedStatusClassification = { ...statusClassification };
                const hasStatusClassification = updatedStatusClassification[newsCurrentId!];
                if (!hasStatusClassification && updatedStatusClassification) {
                    updatedStatusClassification[newsCurrentId!] = response.data;
                    updatedStatusClassification[newsCurrentId!]['statusClassificacao'] = news?.statusClassificacao;
                    return setStatusClassification(updatedStatusClassification);
                }
            });

    };

    const handleClickSave = () => {
        // const hasBoardError = haStatusBoardError();
        const hasError = hasQuestionError() || hasInfluencerDataError();
        if (!hasError) {
            return saveClassification();
        }
        else {
            return homeContext.showError('Ops.. existem campos com preenchimento inválido. Por favor, verifique os campos acima e tente novamente.');
        }
    };

    const hasInfluencerDataError = () => {
        if (!news) return true;
        const errors = validateInfluencerData(news);
        setErrorDataStatus(errors);
        return Object.keys(errors).length > 0;
    };


    const handleClickCheck = () => {
        const hasError = hasInfluencerReviserError();
        if (!hasError) {
            return reviserInfluencer();
        }
        else {
            return homeContext.showError('Ops.. existem campos com preenchimento inválido. Por favor, verifique os campos acima e tente novamente.');
        }
    };

    const hasInfluencerReviserError = () => {
        if (!news) return true;
        const errors = validateInfluencerReviser(news);
        setErrorDataStatus(errors);
        setErros(errors);
        return Object.keys(errors).length > 0;
    };

    const hasQuestionError = () => {
        // Não validamos mais perguntas do tipo 2 (radio) como obrigatórias
        return false;
    };

    const haStatusBoardError = () => {
        const board = statusClassification.statusClassificacao;
        if (!board) {
            return true;
        }
        return false;
    };


    const reviserInfluencer = () => {
        homeContext.setOpenLoadingDialog(true);
        const validadeAnalise = news?.validadeAnalise ?? new Date().toISOString();
        const influencerData = {
            nivelRiscoId: news?.nivelRiscoId,
        };

        if (news) {
            InfluencerService.putStatusRevisorInfluencer(news.id, influencerData)
                .then(() => {
                    homeContext.setOpenLoadingDialog(false);
                    finishSaveAndCallNextNews();
                })
                .catch((error: AxiosError) => {
                    homeContext.setOpenLoadingDialog(false);
                    homeContext.showError('Erro ao Revisar influenciador. <br/>', error);
                });
        }

    };




    const saveClassification = () => {
        if (news) {
            const localDate = new Date(news.validadeAnalise);
            const utcDate = new Date(localDate.getTime() - (localDate.getTimezoneOffset() * 60000));
            const utcDateString = utcDate.toISOString();

            homeContext.setOpenLoadingDialog(true);
            const influencerData = {
                id: news.id,
                dataAnalise: utcDateString,
                validadeAnalise: news.validadeAnalise,
                nome: news.nome,
                url_perfil: news.url_perfil,
                iniciativa: news.iniciativa,
                objetivoContratacao: news.objetivoContratacao,
                marcaId: news.marcaId,
                areaId: news.areaId,
                vpId: news.vpId,
                formatoId: news.formatoId,
                canaisId: news.canaisId,
                abrangenciaId: news.abrangenciaId,
                observacoes: news.observacoes,
                questions: questions,
                territorioId: news.territorioId,
                tamanhoId: news.tamanhoId,
                analiseReputacional: news.analiseReputacional,
                evidencias: news.evidencias,
                statusClassificacao: 11
            };
            InfluencerService.putClassificationInfluencer(influencerData.id, influencerData)
                .then(() => {
                    homeContext.setOpenLoadingDialog(false);
                    finishSaveAndCallNextNews();
                })
                .catch((error: AxiosError) => {
                    homeContext.setOpenLoadingDialog(false);
                    homeContext.showError('Erro ao atualizar influenciador. <br/>', error);
                });
        }
        return;
    };



    const finishSaveAndCallNextNews = async (classification?: ClassificationModel) => {
        homeContext.setAlertProps({
            message: getAlertMessage(classification),
            severity: 'success',
            open: true
        });
        fetchInfluencer();
    };

    const getAlertMessage = (classification?: ClassificationModel) => {
        if (classification) {
            let idMessage = '';
            if (classification.metricId != '')
                idMessage = `ID Metric: ${classification.metricId}`;
            else
                idMessage = `ID Plataforma: ${classification.id}`;

            return (
                <>
                    <Typography variant="caption">
                        A classificação do Influenciador foi salva com sucesso! <br />
                        <strong>{idMessage}</strong>
                    </Typography>
                </>
            );
        }
        else
            return 'A classificação do Influenciador foi salva com sucesso!';
    };




    const getNewsToClassify = () => {
        return (
            <>
                {!loading
                    // && newsContext.listNewsPending.length > 0
                    && newsCurrentId
                    && newsCurrentId > 0 &&
                    <Grid
                        container
                        justify="center"
                        alignItems="center"
                        style={{ overflow: 'hidden' }}
                    >
                        <Grid
                            container
                            justify="center"
                            className={classes.gridContainer}
                            spacing={2}>
                            <Grid item xs={12} >
                                <Typography variant="h3" >
                                    Classificação do Influenciador
                                </Typography>
                            </Grid>
                            <Grid
                                container
                                justify="space-between"
                                className={classes.gridContainerClient}
                                spacing={2}>
                                <Typography variant="h4" color="textSecondary">
                                    {news?.nome}
                                </Typography>
                            </Grid>
                            <Grid
                                container
                                spacing={3}
                                direction="column"
                                alignItems="stretch"
                                justify="center"
                                className={classes.root}>
                                <Accordion defaultExpanded>
                                    <AccordionSummary expandIcon={<Icon className={'material-icons-round'}>expand_more</Icon>}>
                                        <Typography variant="h5">informações do Influenciador</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <InfluencerData news={news} setNews={setNews} setNewsCurrentId={setNewsCurrentId} newsCurrentId={newsCurrentId} />
                                    </AccordionDetails>
                                </Accordion>
                            </Grid>
                            <Grid
                                container
                                spacing={3}
                                direction="column"
                                alignItems="stretch"
                                justify="center"
                                className={classes.root}>
                                <Accordion defaultExpanded>
                                    <AccordionSummary expandIcon={<Icon className={'material-icons-round'}>expand_more</Icon>}>
                                        <Typography variant="h5">DIRETRIZES JURÍDICAS</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <InfluencerDataQuestions
                                            news={news}
                                            setNews={setNews}
                                            setNewsCurrentId={setNewsCurrentId}
                                            newsCurrentId={newsCurrentId}
                                            questions={questions.filter(q => q.categoria === 'DIRETRIZES JURÍDICAS')}
                                            setQuestions={setQuestions}
                                            errorQuestions={errorQuestions}
                                            setErrorQuestions={setErrorQuestions}
                                            statusClassification={statusClassification}
                                            setStatusClassification={setStatusClassification}
                                        />
                                    </AccordionDetails>
                                </Accordion>
                            </Grid>
                            <Grid
                                container
                                spacing={3}
                                direction="column"
                                alignItems="stretch"
                                justify="center"
                                className={classes.root}>
                                <Accordion defaultExpanded>
                                    <AccordionSummary expandIcon={<Icon className={'material-icons-round'}>expand_more</Icon>}>
                                        <Typography variant="h5">VALORES DA COMPANHIA</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <InfluencerDataQuestions
                                            news={news}
                                            setNews={setNews}
                                            setNewsCurrentId={setNewsCurrentId}
                                            newsCurrentId={newsCurrentId}
                                            questions={questions.filter(q => q.categoria === 'VALORES DA COMPANHIA')}
                                            setQuestions={setQuestions}
                                            errorQuestions={errorQuestions}
                                            setErrorQuestions={setErrorQuestions}
                                            statusClassification={statusClassification}
                                            setStatusClassification={setStatusClassification}
                                        />
                                    </AccordionDetails>
                                </Accordion>
                            </Grid>
                            <Grid
                                container
                                spacing={3}
                                direction="column"
                                alignItems="stretch"
                                justify="center"
                                className={classes.root}>
                                <Accordion defaultExpanded>
                                    <AccordionSummary expandIcon={<Icon className={'material-icons-round'}>expand_more</Icon>}>
                                        <Typography variant="h5">FIT CULTURAL</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <InfluencerDataQuestions
                                            news={news}
                                            setNews={setNews}
                                            setNewsCurrentId={setNewsCurrentId}
                                            newsCurrentId={newsCurrentId}
                                            questions={questions.filter(q => q.categoria === 'FIT CULTURAL')}
                                            setQuestions={setQuestions}
                                            errorQuestions={errorQuestions}
                                            setErrorQuestions={setErrorQuestions}
                                            statusClassification={statusClassification}
                                            setStatusClassification={setStatusClassification}
                                        />
                                    </AccordionDetails>
                                </Accordion>
                            </Grid>
                            <Grid container
                                spacing={3}
                                direction="column"
                                alignItems="stretch"
                                justify="center"
                                className={classes.root}>
                                <InfluencerDataReputacao news={news} setNews={setNews} setNewsCurrentId={setNewsCurrentId} newsCurrentId={newsCurrentId}
                                    showErrors={showErrors} erros={erros} />
                            </Grid>
                            <Grid container
                                justifyContent="flex-end"
                                direction="row"
                                spacing={2}
                            >
                                <Grid item xs={4}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleClickSave}
                                        size="large"
                                        fullWidth>
                                        {'CLASSIFICAR'}
                                    </Button>
                                </Grid>
                                <Grid item xs={4}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleClickCheck}
                                        size="large"
                                        fullWidth> {'Revisar'}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                }
            </>
        );
    };

    return (
        <>
            <AppBar position="fixed" className={classes.toolbar} color='inherit' elevation={0}>
                <Grid container justify={openList ? 'flex-start' : 'space-between'}>
                    <Button
                        className={classes.buttonsTop}
                        variant="text"
                        onClick={() => {
                            if (!loading && news && news.id > 0)
                                setShowConfirmExit(true);
                            else
                                homeContext.setPageLocation(PageLocation.INFLUENCER_PROFILE_CLASSIFICATION);
                        }}
                        startIcon={<Icon>arrow_back</Icon>}
                    >

                        Voltar para o histórico de Influenciadores
                    </Button>
                </Grid>
            </AppBar>
            {getNewsToClassify()}
            <BasicConfirmDialog
                title="Sair sem salvar?"
                description="Ao sair sem salvar, você perderá todos os dados de classificação já preenchidos para esta publicação."
                handleFirstButton={() => homeContext.setPageLocation(PageLocation.INFLUENCER_PROFILE_CLASSIFICATION)}
                handleSecondButton={() => setShowConfirmExit(false)}
                textFirstButton="SAIR"
                textSecondButton="Permanecer na página"
                cssProperties={{
                    maxWidth: '550px'
                }}
                open={showConfirmExit} />
        </>
    );
}